
    /**
    * 根据选中类目标号查询所有资质信息（去重）
    *
    **/

    // @ts-nocheck
    import request from '../utils/request/http'
    type Serve<T, G> = (data?: T) => Promise<G>
    /**
 * MainCategoryParam :MainCategoryParam
 */
export class IReqNewSupplierCategoryGetCategoryConfigRespByCategoryNo60874 {
  /**
   * 主营类目列表 ,CategoryPathForm
   */
  mainCategoryPathList?: {
    /**
     * 类目编号路径
     */
    categoryNoPath?: {};
    /**
     * 类目编号
     */
    categoryNo?: {};
    /**
     * 层级
     */
    level?: {};
  }[];
}
    /**
 * YResult<YPageData<CategoryQualificationsResp>> :YResult
 */
export class IResNewSupplierCategoryGetCategoryConfigRespByCategoryNo60874 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YPageData
   */
  data?: {
    /**
     * T
     */
    list?: {
      /**
       * id
       */
      id?: {};
      /**
       * 类目资质编号
       */
      qualificationCode?: {};
      /**
       * 类目资质名称
       */
      qualificationName?: {};
      /**
       * 是否必填:是-必填否-非必填
       */
      qualificationMust?: boolean;
      /**
       * 类目资质说明
       */
      qualificationDesc?: {};
    }[];
    totalNumber?: {};
    totalPage?: {};
    rowId?: {};
    hasNext?: {};
    pageSize?: {};
    pageIndex?: {};
  };
  exceptionMsg?: {};
}
    const http: Serve<IReqNewSupplierCategoryGetCategoryConfigRespByCategoryNo60874, IResNewSupplierCategoryGetCategoryConfigRespByCategoryNo60874> = (data?) =>  request({
      method: 'POST',
      url: '/ywwl-supply-chain/new/supplier/category/getCategoryConfigRespByCategoryNo',
      data:data,
      headers:{'Content-Type': 'application/json;charset=UTF-8'}
    })
    export default http
